const MainIcon = () => (
  <svg
    width="27px"
    height="27px"
    viewBox="0 0 27 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Artboard-Copy-4"
        transform="translate(-338.000000, -554.000000)"
        fill="#EE4C77"
        stroke="#EE4C77"
        strokeWidth="0.644444444"
      >
        <g
          id="Group-2"
          transform="translate(338.000000, 554.000000)"
        >
          <g id="Group-4">
            <g
              id="Group-3"
              transform="translate(0.644444, 0.644444)"
            >
              <path d="M6.91339378,7.08888889 C5.94579911,7.08888889 5.15555556,7.77303088 5.15555556,8.61071204 L5.15555556,16.5226213 C5.15555556,17.3603025 5.94579911,18.0444444 6.91339378,18.0444444 L18.8645902,18.0444444 C19.8319787,18.0444444 20.6222222,17.3603025 20.6222222,16.5226213 L20.6222222,8.61071204 C20.6222222,7.77303088 19.8319787,7.08888889 18.8645902,7.08888889 L6.91339378,7.08888889 L6.91339378,7.08888889 Z M6.91339378,7.69786809 L18.8645902,7.69786809 C19.4550044,7.69786809 19.9190044,8.09956942 19.9190044,8.61071204 L19.9190044,8.63713506 L12.8888889,14.7233564 L5.85877333,8.63713506 L5.85877333,8.61071204 C5.85877333,8.09956942 6.32277333,7.69786809 6.91339378,7.69786809 L6.91339378,7.69786809 Z M5.85877333,9.49784709 L9.48065422,12.6332598 L5.85877333,15.7688511 L5.85877333,9.49838269 L5.85877333,9.49784709 Z M19.9198293,9.49838269 L19.9198293,15.6620878 L16.3600213,12.5802352 L19.9198293,9.49838269 L19.9198293,9.49838269 Z M15.8630258,13.010502 L19.9198293,16.5226213 C19.9198293,17.0339424 19.4558293,17.4356438 18.8654151,17.4356438 L6.91401244,17.4356438 C6.36319289,17.4356438 5.922496,17.0855388 5.86599111,16.62385 L9.97847467,13.0635266 L12.6408036,15.3683995 C12.7777351,15.486946 13.0008676,15.486946 13.1377991,15.3683995 L15.8630258,13.0092523 L15.8630258,13.010502 Z" id="Page-1" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default MainIcon;
